export default "__VITE_ASSET__CkeHjECS__"